import {call, put, select, take} from "redux-saga/effects";
import {getType} from "typesafe-actions";
import {gameInit} from "../actions";
import {closeDialog, showDialog} from "../../dialog-manager/actions";
import {IApplicationState} from "../../index";
import {showBonusAwardDialog} from "../../dialog-manager/dialogs/showBonusAwardDialog";
import {IDailyBonusDialogOptions} from "../../dialog-manager/types";
import {updateDailyStreak} from "../../game/actions";
import {getAddBonusAction} from "../../player/types";

export default function* dailyBonusWorker() {
    yield take(getType(gameInit));

    const {dailyStreak, dailyStreakLastTimeProcessed, dailyBonuses, animation} = yield select(({ game, settings }: IApplicationState) => ({
        dailyStreak: game.dailyStreak,
        dailyStreakLastTimeProcessed: game.dailyStreakLastTimeProcessed,
        dailyBonuses: settings.gameBalance.dailyBonuses,
        animation: settings.animation,
    }));

    const dailyStreakLastTimeProcessedDate = new Date(dailyStreakLastTimeProcessed).getDate();
    const currentDate = new Date().getDate();
    if (dailyStreakLastTimeProcessedDate >= currentDate)
        return;

    const dateDiff = new Date().getTime() - dailyStreakLastTimeProcessed;
    let isStreak = dailyStreakLastTimeProcessedDate !== currentDate && dateDiff < 2 * 24 * 60 * 60 * 1000;

    const currentStreak = isStreak
        ? Math.min(dailyStreak + 1, dailyBonuses.length - 1)
        : 0;

    yield put(showDialog({
        type: 'DailyBonusDialog',
        options: {
            dailyStreak: currentStreak,
            dailyBonuses,
            animation,
        } as IDailyBonusDialogOptions
    }));

    yield take(closeDialog);

    const dailyBonus = dailyBonuses[currentStreak];

    yield showBonusAwardDialog({
        bonus: dailyBonus.bonus,
        count: dailyBonus.amount,
    });

    yield take(closeDialog);

    const bonusAction = yield call(getAddBonusAction, dailyBonus.bonus, dailyBonus.amount, "got_daily_bonus");
    yield put(bonusAction);

    yield put(updateDailyStreak(currentStreak));
}